<template>
  <div>
    <div class="info-box-parent">
      <template v-if="currentGkeTab == 'NODES'">
        <InfoCardBuilder
          :InfoStatData="nodeCardData"
          :scope="scope"
          :isCloudMon="true"
        />
      </template>
    </div>
    <div class="d-flex graphs-container">
      <div v-for="(item, index) in graphData" :key="index" class="graph">
        <MultiLineChart
          v-if="metricList[cloudSvc][currentGkeTab][index]"
          :legendHeaders="headers"
          :data="graphData[index] ? graphData[index] : []"
          highLightColValue="1"
          :intervalTime="intervalTime"
          @openModal="openGraphModal"
          :isSynchronized="isSynchronized"
          :chartId="`chart-${metricList[cloudSvc][currentGkeTab][index].metricName}`"
          :title="metricList[cloudSvc][currentGkeTab][index].title"
          :loading="loading"
          :graphIndex="index"
          :formula="
            formulas[currentGkeTab][
              metricList[cloudSvc][currentGkeTab][index].metricName
            ]
          "
          :Graphlabels="metricList[cloudSvc][currentGkeTab][index].graphTitles"
        />
      </div>
    </div>

    <MultiChartModal
      v-if="graphData.length !== 0"
      :legendHeaders="headers"
      :data="graphData[selectGraphIndex]"
      highLightColValue="1"
      :intervalTime="intervalTime"
      :showGraphModal="showGraphModal"
      @onHide="showGraphModal = false"
      chartId="2dasd"
      infoSpanColIndex="0"
      :title="metricList[cloudSvc][currentGkeTab][selectGraphIndex].title"
      @closeGraphModal="showGraphModal = false"
      :formula="
        formulas[currentGkeTab][
          metricList[cloudSvc][currentGkeTab][selectGraphIndex].metricName
        ]
      "
      :Graphlabels="
        metricList[cloudSvc][currentGkeTab][selectGraphIndex].graphTitles
      "
    />
  </div>
</template>
<script>
import Card from '@/rex-components/rex-card.vue';
import InfoStats from '@/rex-components/rex-info-stats.vue';
import GraphBuilder from '@/components/Common/GraphBuilder.vue';
import MultiLineChart from '@/components/charts/multi-chart';
import InfoCardBuilder from '@/components/Common/InfoCardBuilder.vue';
import { nodeCardData } from '@/components/Cloud/services/k8/node.card.config';
import * as types from '@/store/modules/k8/k8-types';

import MultiChartModal from '@/components/charts/multi-chart-modal';
import { mapGetters, mapState } from 'vuex';
import graphQl from '@/services/graphQl';
import { metricList, GKE_HEADERS_COMMON, formulas, GKE_TABS } from '../util';

export default {
  components: {
    Card,
    InfoStats,
    GraphBuilder,
    MultiLineChart,
    InfoCardBuilder,
    MultiChartModal,
  },
  name: 'NODES',

  data() {
    return {
      infoBoxes: [],
      graphData: [],
      headers: GKE_HEADERS_COMMON,
      nodeCardData: nodeCardData,
      scope: types.k8Scopes.SERVICE,
      showGraphModal: false,
      metricList,
      loading: true,
      selectGraphIndex: 0,
      formulas,
      isSynchronized: true,
    };
  },
  methods: {
    updateBoxes(currentService) {
      const boxes =
        this.chartsTemplate[currentService] &&
        this.chartsTemplate[currentService].NODES.infoBox;
      if (Array.isArray(boxes)) this.infoBoxes = boxes;
      else this.infoBoxes = [];
    },
    async getData() {
      try {
        if (
          this.currentGkeTab !== GKE_TABS.NODE &&
          (!this.currentGKENamespace || !this.currentGKENamespace.key)
        )
          return; //ignore if there is no namespace set

        const apis = [];
        this.loading = true;
        metricList[this.cloudSvc][this.currentGkeTab].forEach((item) => {
          const params = {
            duration: this.getDurationTime,
            condition: {
              name: item.metricName,
              entity: {
                scope: 'Service',
                serviceName: this.currentGKECluster.key || '',
                normal: true,
              },
            },
            valueColumn: item.valueColumn,
            properties: [
              {
                key: 'instanceType',
                value: this.currentGkeTab.replace('S', ''), //This is done because current tab has value with 'S' at end. Eg. PODS etc.
              },
            ],
          };
          if (this.currentGkeTab !== GKE_TABS.NODE) {
            params.properties.push({
              key: 'metaProperty3', //This key is used for storing namespace information
              value: this.currentGKENamespace.key,
            });
          }
          apis.push(graphQl.query('queryGKEservices').params(params));
        });

        const graphsData = await Promise.allSettled(apis);
        this.graphData = [];
        graphsData.forEach((obj) => {
          let readAllMetricService =
            obj?.value?.data?.data?.readAllMetricsAtServiceScopeV2;
          if (readAllMetricService) {
            this.graphData.push(readAllMetricService);
          }
        });
        this.loading = false;
      } catch (error) {
        console.log('error', error);
      }
    },
    openGraphModal(index) {
      this.selectGraphIndex = index;
      this.showGraphModal = true;
    },
  },

  computed: {
    ...mapState('cloudState/services', [
      'cloudSvc',
      'cloudVendor',
      'currentGKECluster',
      'currentGkeTab',
      'currentGKENamespace',
    ]),
    ...mapState('globalState/app', ['chartsTemplate']),
    ...mapGetters('globalState/settings', ['getDurationTime', 'intervalTime']),
  },

  watch: {
    cloudSvc(newVal) {
      this.updateBoxes(newVal);
    },
    intervalTime(newVak) {},
    getDurationTime() {
      this.getData();
    },
    currentGKECluster(newVal, oldVal) {
      if (newVal.key != oldVal.key) this.getData();
    },
    currentGKENamespace(newVal, oldVal) {
      if (newVal.key != oldVal.key && this.currentGkeTab != GKE_TABS.NODE)
        this.getData();
    },
    currentGkeTab() {
      this.getData();
    },
  },
  async mounted() {
    this.updateBoxes(this.cloudSvc);
    this.getData();
  },
  created() {},
};
</script>
<style scoped>
.info-cards {
  /* max-width: auto !important; */
}
.info-box-container {
  gap: 1rem;
  justify-content: space-between;
}
.info-box {
  flex: 1;
}
.info-box-parent {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.graphs-container {
  gap: 1rem;
  flex-wrap: wrap;
}
.graph {
  width: 48%;
  min-width: 30rem;
  min-height: 30rem;
}
</style>
